import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
import loadConfig from "@Web3WalletConfig/config";
export default {
  name: "gift",
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", 'setting'])
  },
  data() {
    return {
      loadConfig,
      isLock: false,
      list: [],
      popGitfShow: false,
      modifyData: {
        "icon": ""
      },
      isLoading: false,
      isSyncLoading: false,
      selectTab: 0,
      total: 0,
      condition: {
        gift_type: -1,
        page: 1,
        limit: 15
      }
    };
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let rs = await this.$http.post("/gift/list", {
        status: this.selectTab == 0 ? 1 : 0,
        ...this.condition
      });
      this.isLoading = false;
      if (rs.code == 0) {
        this.list = rs.data.items;
        this.total = rs.data.total;
      }
    },
    async onCreate() {
      this.modifyData = {
        "gift_thumb": "",
        'status': "1",
        "gift_type": '1'
      };
      this.popGitfShow = true;
    },
    async onSyncGifts() {
      if (this.isSyncLoading) return;
      this.isSyncLoading = true;
      let rs = await this.$http.post("/syncgifts", {});
      this.getData();
      this.isSyncLoading = false;
    },
    async onModify(item) {
      this.modifyData = item;
      this.popGitfShow = true;
    },
    cutStr(str) {
      if (str) return str.replace("T", " ").replace(".000Z", "");
    },
    onRefresh() {
      this.getData();
    },
    onPageChange(e) {
      this.condition.page = e;
      this.getData();
    },
    onPageSizeChange(e) {
      this.condition.limit = e;
      this.getData();
    }
  },
  mounted() {
    this.getData();
  }
};